import ManagerAdditionalFilters from "@/entities/scheduler/additionalFiltersInterfaces/ManagerAdditionalFilters";
import ManagerViewFiltersToWatch from "@/entities/scheduler/additionalFiltersInterfaces/ManagerVIewFIltersToWatch";
import ManagerRadioButtonOptions from "@/entities/scheduler/ManagerRadioButtonOptions";

const managerViewFiltersTemplate:
  | ManagerAdditionalFilters
  | ManagerViewFiltersToWatch = {
  countries: [],
  states: [],
  cities: [],
  orderByChosenOption: ManagerRadioButtonOptions.MOST_PROJECTS_FIRST,
  users: [],
};

export default managerViewFiltersTemplate;
